import axios from 'axios'
import { getCookie } from '../../common/cookie'

export const Api = {
    baseUrl: process.env.REACT_APP_API_URL,

    getEvents(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/list`
        return axios.post(_url, params, config)
    },

    getEventWin(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/winList/${params}`
        return axios.post(_url, {}, config)
    },

    getEventDetail(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/view/${params}`
        return axios.get(_url, {}, config)
    },

    getEvtWinComment(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/winBbsList/${params.idx_cat_evt}`
        return axios.post(_url, params, config)
    },

    pushEvtWinComment(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/winBbsRegist/${params.idx_cat_evt}`
        return axios.post(_url, params, config)
    },

    chgWinCmtState(params) {
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        const _url = `${this.baseUrl}/front/v2/event/winBbsState/${params.idx_threads}`
        return axios.post(_url, params, config)
    },

    getUserInfo() {
        const _url = `${this.baseUrl}/front/v2/user/info`
        const authToken = getCookie('auth_token')
        const config = {
            withCredentials: true,
            xsrfHeaderName: 'Authorization',
        }
        return axios.post(_url, { authToken }, config)
    },
}

export default Api
